import React, { useRef, useState } from "react"
import PropTypes from "prop-types"
import { Pie } from "react-chartjs-2"
import { useTranslation } from "react-i18next"

// Chart.js draws its legend on the canvas, which cannot scroll. This renders the
// same side legend as HTML so a long label scrolls instead of being cut off.
const PieWithScrollableLegend = ({ data, options, ...pieProps }) => {
  const { i18n } = useTranslation()
  const chartRef = useRef(null)
  const [hiddenIndexes, setHiddenIndexes] = useState([])

  const labels = data?.labels || []
  const colors = [].concat(data?.datasets?.[0]?.backgroundColor || [])

  const toggleSlice = index => {
    const chart = chartRef.current
    if (!chart) return
    chart.toggleDataVisibility(index)
    chart.update()
    setHiddenIndexes(current =>
      current.includes(index)
        ? current.filter(item => item !== index)
        : [...current, index]
    )
  }

  return (
    <div
      className={`pie-scroll-legend${
        // These charts fill a fixed-height parent instead of keeping a square.
        options?.maintainAspectRatio === false ? " pie-scroll-legend--fill" : ""
      }`}
    >
      <div className="pie-scroll-legend__chart">
        <Pie
          {...pieProps}
          ref={chartRef}
          data={data}
          options={{
            ...options,
            plugins: {
              ...options?.plugins,
              legend: { display: false },
            },
          }}
        />
      </div>
      <ul className="pie-scroll-legend__list">
        {labels.map((label, index) => (
          <li key={`${label}-${index}`} className="pie-scroll-legend__item">
            <button
              type="button"
              className="pie-scroll-legend__swatch"
              style={{ backgroundColor: colors[index % colors.length] }}
              aria-label={label}
              aria-pressed={!hiddenIndexes.includes(index)}
              onClick={() => toggleSlice(index)}
            />
            <div
              className="pie-scroll-legend__scroller"
              dir={i18n.language === "sa" ? "rtl" : "ltr"}
            >
              <span
                className={`pie-scroll-legend__label${
                  hiddenIndexes.includes(index)
                    ? " pie-scroll-legend__label--hidden"
                    : ""
                }`}
                title={label}
                onClick={() => toggleSlice(index)}
              >
                {label}
              </span>
            </div>
          </li>
        ))}
      </ul>
    </div>
  )
}

PieWithScrollableLegend.propTypes = {
  data: PropTypes.object,
  options: PropTypes.object,
}

export default PieWithScrollableLegend
